import axios from 'axios';

const apiUrl = process.env.CA_IF_API_URL || '[Env var not set: CA_IF_API_URL]';

axios.defaults.withCredentials = true;

export const reqDelete = async (resource, data) => {

  try {
    const req = await axios({
      method: 'delete',
      url: apiUrl + resource,
      data: data,
      withCredentials: true
    });

    return req;
  }
  catch (error) {
    throw error;
  }
}

